import React, { useEffect } from 'react';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the component is mounted
  }, []);
  return (
        <div className=" text-white mt-24 bg-gradient-to-r from-[#121212] to-[#10204d] min-h-screen p-8">
          <div className="max-w-4xl mx-auto  p-6  ">
            <h1 className="text-3xl font-bold text-center mb-6 text-transparent bg-clip-text bg-gradient-to-r from-[#F9B5FB] to-[#921196]">Privacy Policy</h1>
            <p className="text-sm text-gray-500 text-center mb-6">Last updated: 21/10/2024</p>
            
            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-2 text-transparent bg-clip-text bg-gradient-to-r from-[#F9B5FB] to-[#921196]">
                1. Information We Collect
              </h2>
              <p className="mb-2 font-thin">
                <strong className="font-semibold">Personal Information:</strong> Name, email address, phone number, business details, and other information you provide when contacting us or using our services.
              </p>
              <p className="mb-2 font-thin">
                <strong className="font-semibold">Usage Data:</strong> Information about how you interact with our website, including your IP address, browser type, and pages visited.
              </p>
              <p className="mb-2 font-thin">
                <strong className="font-semibold">Cookies:</strong> Small data files stored on your device to enhance your browsing experience and improve website performance.
              </p>
            </section>
    
            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-2 text-transparent bg-clip-text bg-gradient-to-r from-[#F9B5FB] to-[#921196]">
                2. How We Use Your Information
              </h2>
              <ul className="list-disc ml-6 space-y-1 font-thin">
                <li>Provide and maintain our services</li>
                <li>Respond to inquiries and offer customer support</li>
                <li>Improve our website and offerings</li>
                <li>Send promotional communications (if opted in)</li>
                <li>Analyze website usage for performance improvements</li>
              </ul>
            </section>
    
            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-2 text-transparent bg-clip-text bg-gradient-to-r from-[#F9B5FB] to-[#921196]">
                3. How We Share Your Information
              </h2>
              <p className="mb-2 font-thin">
                We do not sell or rent your personal information to third parties. We may share your data with service providers or as required by law.
              </p>
            </section>
    
            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-2 text-transparent bg-clip-text bg-gradient-to-r from-[#F9B5FB] to-[#921196]">
                4. Cookies and Tracking Technologies
              </h2>
              <p className="mb-2 font-thin">
                We use cookies and similar tracking technologies to monitor user behavior and enhance the user experience. You can manage cookie preferences through your browser settings.
              </p>
            </section>
    
            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-2 text-transparent bg-clip-text bg-gradient-to-r from-[#F9B5FB] to-[#921196]">
                5. Data Security
              </h2>
              <p className="mb-2 font-thin">
                We employ industry-standard security measures to protect your data from unauthorized access, disclosure, or alteration.
              </p>
            </section>
    
            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-2 text-transparent bg-clip-text bg-gradient-to-r from-[#F9B5FB] to-[#921196]">
                6. Your Data Rights
              </h2>
              <p className="mb-2 font-thin">
                Depending on your location, you may have the right to access, correct, or delete your personal data. Contact us at <a href="mailto:zenhook92@gmail.com" className="text-blue-500">zenhook92@gmail.com</a> to exercise these rights.
              </p>
            </section>
    
            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-2 text-transparent bg-clip-text bg-gradient-to-r from-[#F9B5FB] to-[#921196]">
                7. Changes to This Privacy Policy
              </h2>
              <p className="mb-2 font-thin">
                We may update this policy periodically. Please review it regularly to stay informed of changes.
              </p>
            </section>
    
            <section className="mb-6">
              <h2 className="text-xl font-semibold mb-2 text-transparent bg-clip-text bg-gradient-to-r from-[#F9B5FB] to-[#921196]">
                8. Contact Us
              </h2>
              <p className="mb-2 font-thin">Zenhook</p>
              <p className="font-thin">Email: <a href="mailto:zenhook92@gmail.com" className="text-blue-500">zenhook92@gmail.com</a></p>
              <p className="font-thin">Phone: 93636 52998</p>
              <p className="font-thin">Address: 64, Pettai Road, Dindigul-624002</p>
            </section>
          </div>
    
        
        </div>

  )

};

export default PrivacyPolicy;
